import { isLocalDev } from '../platform/environment';
import { defaultTenantConfig, defaultConfig } from './config.default';

const host = /*#__PURE__*/ (() => window.location.origin)();
const config = /*#__PURE__*/ (() => ({
  ...defaultConfig,

  region: 'asia-cis',
  avatarDomain: `${host}/goapi`,
  host: isLocalDev ? '' : host,
  hostForGo: isLocalDev ? '/goapi' : `${host}/goapi`,
  collectHost: 'https://miigo-monitor.bytedance.com/inner',

  guideLink: 'https://bytedance.feishu.cn/docs/doccnhGBz5VDr5xFsGV9bGgcpwe',
  currentHost: host,
  tosBucket: 'ad-qa-mission',
  // larkLoginHost: 'https://www.feishu.cn',
  larkLoginHost: host.replace('meego-my', 'www'),
  tenantConfig: defaultTenantConfig,
  bytereplayEnv: 'PROD-INTERNAL',
  labProjectId: '620b229097e53d8b28d33e98',
  labViewId: 'bpcVAgB7RZ',
  showTenantIds: '1',
  helpcenterUrl: host + '/helpcenter/home',
  internalApi: host.replace('https://meego-my', 'internal-api-lark-api'),
  passportApi: host.replace('https://meego-my', 'passport'),
  applinkApi: host.replace('https://meego-my', 'applink'),
}))();

export default config;
